export default {
    topics: [
        {
            title: ' appendBase64 ',
            href: 'm-MemoryBuffer-appendBase64.html',
            attributes: { 'data-id': 'm-MemoryBuffer-appendBase64' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-appendBase64-d66e5071',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-MemoryBuffer-dispose.html',
            attributes: { 'data-id': 'm-MemoryBuffer-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-dispose-d66e5079',
            topics: [],
        },
        {
            title: ' fromHexString ',
            href: 'm-MemoryBuffer-fromHexString.html',
            attributes: { 'data-id': 'm-MemoryBuffer-fromHexString' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-fromHexString-d66e5087',
            topics: [],
        },
        {
            title: ' fromString ',
            href: 'm-MemoryBuffer-fromString.html',
            attributes: { 'data-id': 'm-MemoryBuffer-fromString' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-fromString-d66e5095',
            topics: [],
        },
        {
            title: ' hmac ',
            href: 'm-MemoryBuffer-hmac.html',
            attributes: { 'data-id': 'm-MemoryBuffer-hmac' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-hmac-d66e5103',
            topics: [],
        },
        {
            title: ' isEmpty ',
            href: 'p-MemoryBuffer-isEmpty.html',
            attributes: { 'data-id': 'p-MemoryBuffer-isEmpty' },
            menu: { hasChildren: false },
            tocID: 'p-MemoryBuffer-isEmpty-d66e5111',
            topics: [],
        },
        {
            title: ' load ',
            href: 'm-MemoryBuffer-load.html',
            attributes: { 'data-id': 'm-MemoryBuffer-load' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-load-d66e5119',
            topics: [],
        },
        {
            title: ' removeAll ',
            href: 'm-MemoryBuffer-removeAll.html',
            attributes: { 'data-id': 'm-MemoryBuffer-removeAll' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-removeAll-d66e5127',
            topics: [],
        },
        {
            title: ' save ',
            href: 'm-MemoryBuffer-save.html',
            attributes: { 'data-id': 'm-MemoryBuffer-save' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-save-d66e5135',
            topics: [],
        },
        {
            title: ' sha1 ',
            href: 'm-MemoryBuffer-sha1.html',
            attributes: { 'data-id': 'm-MemoryBuffer-sha1' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-sha1-d66e5143',
            topics: [],
        },
        {
            title: ' sha224 ',
            href: 'm-MemoryBuffer-sha224.html',
            attributes: { 'data-id': 'm-MemoryBuffer-sha224' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-sha224-d66e5152',
            topics: [],
        },
        {
            title: ' sha256 ',
            href: 'm-MemoryBuffer-sha256.html',
            attributes: { 'data-id': 'm-MemoryBuffer-sha256' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-sha256-d66e5160',
            topics: [],
        },
        {
            title: ' sha384 ',
            href: 'm-MemoryBuffer-sha384.html',
            attributes: { 'data-id': 'm-MemoryBuffer-sha384' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-sha384-d66e5168',
            topics: [],
        },
        {
            title: ' sha512 ',
            href: 'm-MemoryBuffer-sha512.html',
            attributes: { 'data-id': 'm-MemoryBuffer-sha512' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-sha512-d66e5176',
            topics: [],
        },
        {
            title: ' size ',
            href: 'p-MemoryBuffer-size.html',
            attributes: { 'data-id': 'p-MemoryBuffer-size' },
            menu: { hasChildren: false },
            tocID: 'p-MemoryBuffer-size-d66e5184',
            topics: [],
        },
        {
            title: ' toBase64 ',
            href: 'm-MemoryBuffer-toBase64.html',
            attributes: { 'data-id': 'm-MemoryBuffer-toBase64' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-toBase64-d66e5192',
            topics: [],
        },
        {
            title: ' toDocument ',
            href: 'm-MemoryBuffer-toDocument.html',
            attributes: { 'data-id': 'm-MemoryBuffer-toDocument' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-toDocument-d66e5200',
            topics: [],
        },
        {
            title: ' toHexString ',
            href: 'm-MemoryBuffer-toHexString.html',
            attributes: { 'data-id': 'm-MemoryBuffer-toHexString' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-toHexString-d66e5208',
            topics: [],
        },
        {
            title: ' toString ',
            href: 'm-MemoryBuffer-toString.html',
            attributes: { 'data-id': 'm-MemoryBuffer-toString' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-toString-d66e5216',
            topics: [],
        },
        {
            title: ' toXML ',
            href: 'm-MemoryBuffer-toXML.html',
            attributes: { 'data-id': 'm-MemoryBuffer-toXML' },
            menu: { hasChildren: false },
            tocID: 'm-MemoryBuffer-toXML-d66e5224',
            topics: [],
        },
    ],
};

